<template>
  <v-dialog
    v-model="opened"
    content-class="video-dialog"
    max-width="950"
    max-heigth="500"
    persistent
  >
    <video ref="video" :src="src" controls></video>
    <v-btn
      class="video-dialog__close"
      color="warning"
      icon
      large
      @click="opened = false"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-dialog>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    src: {
      type: String,
      default: '',
    },
  },
  watch: {
    opened(val) {
      if (val) return;
      this.$refs.video.pause();
      this.$refs.video.currentTime = 0;
    },
  },
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
  },
};
</script>

<style lang="scss">
.video-dialog {
  video {
    display: block;
    width: 100%;
    max-height: 600px;
    background-color: #464646;
  }

  &__close {
    position: absolute;
    top: 5px;
    right: 5px;
  }
}
</style>
